import { render } from "./EditLesson.vue?vue&type=template&id=74950fcb&scoped=true"
import script from "./EditLesson.vue?vue&type=script&lang=js"
export * from "./EditLesson.vue?vue&type=script&lang=js"

import "./EditLesson.vue?vue&type=style&index=0&id=74950fcb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74950fcb"]])

export default __exports__